import { ComponentMultiStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps } from '@chakra-ui/theme-tools';
import { getColor } from '@chakra-ui/theme-tools';

import { getFocusedOutlineShadow } from 'theme/shadows';

const CheckBoxTheme: ComponentMultiStyleConfig = {
  parts: ['control', 'icon', 'label'],
  baseStyle: (props: StyleFunctionProps) => {
    return {
      control: {
        _light: {
          bg: 'silver.lightest',
          border: `1px solid ${getColor(props.theme, 'grey.lightest')}`,
          _checked: {
            bg: 'blue.base',
            border: `1px solid ${getColor(props.theme, 'blue.base')}`,
            _hover: {
              bg: 'blue.dark',
              border: `1px solid ${getColor(props.theme, 'blue.darker')}`
            }
          },
          _disabled: {
            bg: 'silver.base',
            border: 'none',
            _hover: {
              bg: 'silver.base'
            },
            '& svg': {
              color: 'grey.lighter'
            }
          },
          _indeterminate: {
            ':not([data-disabled])': {
              bg: 'blue.base',
              border: `1px solid ${getColor(props.theme, 'blue.base')}`,
              _hover: {
                bg: 'blue.dark',
                border: `1px solid ${getColor(props.theme, 'blue.darker')}`
              }
            }
          },
          _focus: {
            boxShadow: getFocusedOutlineShadow(props)
          },
          _hover: {
            bg: 'silver.light'
          }
        },
        _dark: {
          bg: 'black.base',
          border: `1px solid ${getColor(props.theme, 'grey.base')}`,
          _checked: {
            bg: 'blue.base',
            border: `1px solid ${getColor(props.theme, 'blue.base')}`,
            _hover: {
              bg: 'blue.dark'
            }
          },
          _indeterminate: {
            ':not([data-disabled])': {
              bg: 'blue.base',
              border: `1px solid ${getColor(props.theme, 'blue.base')}`,
              _hover: {
                bg: 'blue.dark'
              }
            }
          },
          _focus: {
            boxShadow: getFocusedOutlineShadow(props)
          },
          _disabled: {
            bg: 'black.lighter',
            border: 'none',
            _hover: {
              bg: 'black.lighter'
            },
            '& svg': {
              color: 'grey.light'
            }
          },
          _hover: {
            bg: 'black.lighter'
          }
        }
      },
      icon: {
        color: 'silver.lightest'
      }
    };
  },
  sizes: {
    sm: {
      control: {
        w: '12px',
        h: '12px',
        borderRadius: '2px'
      },
      label: {
        fontSize: '12px',
        marginInlineStart: '8px'
      },
      icon: {
        w: '7.5px',
        h: '6px'
      }
    },
    md: {
      control: {
        w: '16px',
        h: '16px',
        borderRadius: '4px'
      },
      label: {
        fontSize: '14px',
        marginInlineStart: '12px'
      },
      icon: {
        w: '10px',
        h: '8px'
      }
    },
    lg: {
      control: {
        w: '20px',
        h: '20px',
        borderRadius: '6px'
      },
      label: {
        fontSize: '17px',
        marginInlineStart: '16px'
      },
      icon: {
        w: '12px',
        h: '10px'
      }
    }
  },
  defaultProps: {
    colorScheme: undefined
  }
};

export default CheckBoxTheme;
